import * as events from '../base/constant';
import { detach, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * XhtmlValidation module called when set enableXhtml as true
 */
export class XhtmlValidation {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.on(events.xhtmlValidation, this.enableXhtmlValidation, this);
        this.parent.on(events.destroy, this.removeEventListener, this);
    }
    removeEventListener() {
        this.parent.off(events.xhtmlValidation, this.enableXhtmlValidation);
        this.parent.off(events.destroy, this.removeEventListener);
    }
    enableXhtmlValidation() {
        if (this.parent.enableXhtml) {
            if (isNullOrUndefined(this.parent.inputElement)) {
                this.currentElement = this.parent.element;
            }
            else {
                this.currentElement = this.parent.inputElement;
            }
            this.clean(this.currentElement);
            this.ImageTags();
            this.removeTags();
            this.RemoveUnsupported();
            this.currentElement.innerHTML = this.selfEncloseValidation(this.currentElement.innerHTML, this.currentElement.innerText === '\n' ?
                this.currentElement.innerText.length : this.currentElement.innerText.trim().length);
            this.parent.setProperties({ value: this.currentElement.innerHTML }, true);
        }
    }
    /**
     * @param {string} currentValue - specifies the string value.
     * @param {number} valueLength - specifies the length of the current value.
     * @returns {void}
     * @deprecated
     */
    selfEncloseValidation(currentValue, valueLength) {
        if (valueLength === 0 && currentValue.indexOf('table') < 0 && currentValue.indexOf('img') < 0 &&
            currentValue.includes('&nbsp;')) {
            const arrayValue = currentValue.split('&nbsp;');
            arrayValue[arrayValue.length - 1] = '&#8203;' + arrayValue[arrayValue.length - 1];
            currentValue = arrayValue.join('');
        }
        currentValue = currentValue.replace(/<br>/g, '<br/>').replace(/<hr>/g, '<hr/>').replace(/ /g, ' ');
        let valueTemp;
        const valueDupe = [];
        let valueOriginal = [];
        const imgRegexp = [/<img(.*?)>/gi, /<area(.*?)>/gi, /<base(.*?)>/gi, /<col (.*?)>/gi, /<embed(.*?)>/gi,
            /<input(.*?)>/gi, /<link(.*?)>/gi, /<meta(.*?)>/gi, /<param(.*?)>/gi, /<source(.*?)>/gi,
            /<track(.*?)>/gi, /<wbr(.*?)>/gi];
        for (let j = 0; j < imgRegexp.length; j++) {
            valueTemp = imgRegexp[j].exec(currentValue);
            while ((valueTemp) !== null) {
                valueDupe.push(valueTemp[0].toString());
                valueTemp = imgRegexp[j].exec(currentValue);
            }
            valueOriginal = valueDupe.slice(0);
            for (let i = 0; i < valueDupe.length; i++) {
                if (valueDupe[i].indexOf('/') === -1 || valueDupe[i].lastIndexOf('/') !== valueDupe[i].length - 2) {
                    valueDupe[i] = valueDupe[i].substr(0, valueDupe[i].length - 1) + ' /' +
                        valueDupe[i].substr(valueDupe[i].length - 1, valueDupe[i].length);
                }
            }
            for (let g = 0; g <= valueDupe.length - 1; g++) {
                currentValue = currentValue.replace(valueOriginal[g], valueDupe[g]);
            }
        }
        return currentValue;
    }
    clean(node) {
        for (let n = 0; n < node.childNodes.length; n++) {
            const child = node.childNodes[n];
            if (child.nodeType === 8 || child.nodeName === 'V:IMAGE') {
                node.removeChild(child);
                n--;
            }
            else if (child.nodeType === 1) {
                this.clean(child);
            }
        }
        return this.currentElement.innerHTML;
    }
    ImageTags() {
        const imgNodes = this.currentElement.querySelectorAll('IMG');
        for (let i = imgNodes.length - 1; i >= 0; i--) {
            if (!imgNodes[i].hasAttribute('alt')) {
                const img = imgNodes[i];
                img.setAttribute('alt', '');
            }
        }
    }
    removeTags() {
        const removeAttribute = [['br', 'ul'], ['br', 'ol'], ['table', 'span'], ['div', 'span'], ['p', 'span']];
        for (let i = 0; i < removeAttribute.length; i++) {
            this.RemoveElementNode(removeAttribute[i][0], removeAttribute[i][1]);
        }
    }
    RemoveElementNode(rmvNode, parentNode) {
        const parentArray = this.currentElement.querySelectorAll(parentNode);
        for (let i = 0; i < parentArray.length; i++) {
            const rmvArray = parentArray[i].querySelectorAll(rmvNode);
            for (let j = rmvArray.length; j > 0; j--) {
                detach(rmvArray[j - 1]);
            }
        }
    }
    RemoveUnsupported() {
        const underlineEle = this.currentElement.querySelectorAll('u');
        for (let i = underlineEle.length - 1; i >= 0; i--) {
            const spanEle = this.parent.createElement('span');
            spanEle.style.textDecoration = 'underline';
            spanEle.innerHTML = underlineEle[i].innerHTML;
            underlineEle[i].parentNode.insertBefore(spanEle, underlineEle[i]);
            detach(underlineEle[i]);
        }
        const strongEle = this.currentElement.querySelectorAll('strong');
        for (let i = strongEle.length - 1; i >= 0; i--) {
            const boldEle = this.parent.createElement('b');
            boldEle.innerHTML = strongEle[i].innerHTML;
            strongEle[i].parentNode.insertBefore(boldEle, strongEle[i]);
            detach(strongEle[i]);
        }
        const attrArray = ['language', 'role', 'target', 'contenteditable', 'cellspacing',
            'cellpadding', 'border', 'valign', 'colspan'];
        for (let i = 0; i <= attrArray.length; i++) {
            this.RemoveAttributeByName(attrArray[i]);
        }
    }
    RemoveAttributeByName(attrName) {
        if (this.currentElement.firstChild !== null) {
            for (let i = 0; i < this.currentElement.childNodes.length; i++) {
                this.processNodeAndDescendants(this.currentElement.childNodes[i], attrName);
            }
        }
    }
    shouldRemoveAttribute(ele, attrName) {
        const htmlEle = ele;
        const isTableElement = ele.nodeName === 'TABLE' || ele.nodeName === 'TBODY' ||
            ele.nodeName === 'THEAD' || ele.nodeName === 'TH' || ele.nodeName === 'TR' || ele.nodeName === 'TD';
        const isAnchorWithTarget = ele.nodeName === 'A' && attrName === 'target';
        const isMentionChip = htmlEle.nodeType !== 3 && htmlEle.hasAttribute(attrName) && htmlEle.classList.contains('e-mention-chip');
        return ele.nodeType !== 3 && !isTableElement && !isAnchorWithTarget && !isMentionChip && htmlEle.hasAttribute(attrName);
    }
    processNodeAndDescendants(ele, attrName) {
        if (this.shouldRemoveAttribute(ele, attrName)) {
            ele.removeAttribute(attrName);
        }
        // Process all descendants recursively at all levels
        if (ele.hasChildNodes()) {
            for (let i = 0; i < ele.childNodes.length; i++) {
                this.processNodeAndDescendants(ele.childNodes[i], attrName);
            }
        }
    }
}
